import { NavLink } from 'react-router-dom';
import { ButtonTheme } from '../buttons/button-theme';
import { getThemeClasses } from '../buttons/button-functions';

interface NavLinkButtonProps {
  theme: ButtonTheme;
  identifier: string;
  classOverrides?: string;
  to: string;
  children: JSX.Element | JSX.Element[];
}

export default function NavLinkButton({
  theme,
  identifier,
  classOverrides,
  to,
  children
}: NavLinkButtonProps) {
  const classes = classOverrides ?? 'px-4 py-2.5';
  const themeClasses = getThemeClasses(theme);

  return (
    <>
      <NavLink
        to={to}
        id={identifier}
        className={`relative transition-all text-sm rounded border text-center ${themeClasses} ${classes}`}
      >
        {children}
      </NavLink>
    </>
  );
}
